import React from "react";
import {
  Box,
  Heading,
  Flex,
  Stat,
} from "@chakra-ui/react";

const BranchesOverviewCard = ({ data, index, totalIndexes }) => {
  return (
    <Box
      p={"15px"}
      borderRadius={
        index === 0
          ? "10px 10px 0 0" // Top left and top right
          : index === totalIndexes - 1
            ? "0 0 10px 10px" // Bottom left and bottom right
            : "0" // No border radius
      }
      border="1px solid var(--borderGrey)"
      borderBottom={index === totalIndexes - 1 ? "1px solid var(--borderGrey)" : "none"}
    >
      <Heading fontSize="20px" mb={"10px"}>{data.branchName}</Heading>
      <Flex justify="space-between">
        <Stat.Root>
          <Stat.Label>Total</Stat.Label>
          <Stat.ValueText fontSize="16px" fontWeight={400}>{data.total}</Stat.ValueText>
        </Stat.Root>
        <Stat.Root>
          <Stat.Label>Completed</Stat.Label>
          <Stat.ValueText fontSize="16px" fontWeight={400}>{data.completed}</Stat.ValueText>
        </Stat.Root>
        <Stat.Root>
          <Stat.Label>Active</Stat.Label>
          <Stat.ValueText fontSize="16px" fontWeight={400}>{data.active}</Stat.ValueText>
        </Stat.Root>
        <Stat.Root>
          <Stat.Label>In Queue</Stat.Label>
          <Stat.ValueText fontSize="16px" fontWeight={400}>{data.inQueue}</Stat.ValueText>
        </Stat.Root>
        <Stat.Root>
          <Stat.Label>No Show</Stat.Label>
          <Stat.ValueText fontSize="16px" fontWeight={400}>{data.noShow}</Stat.ValueText>
        </Stat.Root>
      </Flex>
    </Box>
  );
};

export default BranchesOverviewCard;
